<div class="metrics-container">
  <!-- <h2>{{ title }}</h2> -->

  <!-- <div class="no-metrics-check" *ngIf="metrics.length">
    <div class="metric-container" *ngFor="let metric of metrics">
      <div class="metric-label">
        {{ metric.name }}:
      </div>
      <div [ngClass]="getMetricClass(metric)">
        {{ metric.value['display'] }}
      </div>
    </div>
  </div> -->

  <div class="no-metrics-check" *ngIf="metrics.length">
    <div class="metric-container1" *ngFor="let metric of metrics">
      <div class="metricsDiv">
        <div class="metricName">{{ metric.name }} </div>
        <div class="metricVal" [class]="metric.className + ' metric-value'">{{ formatMetricDisplay(metric) }}</div>
      </div>
    </div>
  </div>
  <div class="no-metrics-check" *ngIf="!metrics.length">
    <h3>No metrics found.</h3>
  </div>
</div>

